// extracted by mini-css-extract-plugin
module.exports = {"root":"Y_b4"};